import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { homeSelector } from "redux/selectors/homeSelector";
import { envSelector } from "redux/selectors/envSelector";
import "./style.scss";
import { useMutation } from "@tanstack/react-query";
import httpClient from "../../../api/module/httpClient";
import IconLoading from "images/icon-loading.gif";

function CertificateLearning({ isMobile, idEvent }) {
  const { code:uniqueCode } = useParams();

    const { isLoading , mutate,  data: diploma }  = useMutation({
        mutationFn: async ({ idEvent }) => {
            let data = await httpClient.get(
                `private/vandel/vandel/${uniqueCode}`,{
                    params: {
                        CertificateId: idEvent 
                    }
                }
            );
            return data.data
        },
    });

    useEffect(() => {
        mutate({uniqueCode,idEvent})
    },[uniqueCode,idEvent])

    return (<>
        <div
            className="container-crashcourse-verify"
            style={{
                ...(localStorage.getItem("community") ? {} : { marginTop: "3rem" }),
            }}
        >
            <div className="container-profile-certificate" style={isMobile ? { overflow:'hidden scroll', padding:'0px'} : {padding:'0px'}}>
                <div className="container-certificate" style={isMobile ? {marginBottom: '-200px', width:'100%'} : {width:'100%'}}>
                    <div>
                        {isLoading ? (
                            <div
                                style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                }}
                            >
                                <img
                                    src={IconLoading}
                                    style={{ width: "40px", height: "40px" }}
                                    alt="loader-digital-certificate"
                                />
                            </div>
                        ) : (
                            <img
                                src={`data:image/png;base64,${diploma?.image}`}
                                alt="ceritficate-case"
                                style={{ width: "100%", height: "100%" }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    </>);
}

const mapStateToProps = (state) => ({
  userProfile: homeSelector(state).userProfile,
  isMobile: envSelector(state).isMobile,
});

export default connect(mapStateToProps)(CertificateLearning);